import { FC } from "react";
import { Photo } from "@models/photo";
import styled from "@emotion/styled";
import { PhotoAlbum } from '@mui/icons-material';

const Wrapper = styled.div<{ active: boolean }>`
  padding: 5px;
  border-radius: 4px;
  border: solid 2px;
  ${(props) => ({
    borderColor: props.active ? "#1E64DDFF" : "transparent",
  })};
  box-sizing: border-box;
  height: 130px;
  overflow: hidden;
`;

const ImageContainer = styled.div`
  position: relative;
  height: 100%;
`;

const Image = styled.img`
  height: 100%;
  width: auto;
  border-radius: 4px;
`;

const StyledCheckbox = styled.input`
  position: absolute;
  top: 2px;
  right: 2px;
  cursor: pointer;
  width: 16px;
  height: 16px;
`;

const StyledIconDiv = styled.div`
  position: absolute;
  bottom: 12px;
  left: 2px;
  cursor: pointer;
  width: 16px;
  height: 16px;
`;

const Picture: FC<{
  picture: Photo;
  selected: boolean;
  checked: boolean;
  onCheck?: () => void;
  coverPicture: boolean;
}> = ({ picture, checked, selected, onCheck, coverPicture }) => {
  const src =
    picture.fileUrl || process.env.PUBLIC_URL + "/images/file-placeholder.png";

  return (
    <Wrapper active={selected}>
      <ImageContainer>
        {onCheck && (
          <StyledCheckbox
            checked={checked}
            type="checkbox"
            onChange={onCheck}
            onClick={(e) => e.stopPropagation()}
          />
        )}
        {coverPicture && (
          <StyledIconDiv>
            <PhotoAlbum htmlColor="#fff"/>
          </StyledIconDiv>
        )}
        <Image src={src} />
      </ImageContainer>
    </Wrapper>
  );
};

export default Picture;
